export enum ViewsEnumDeprecate {
  dashboard,
  companies,
  backtest,
  users,
  news,
  publishing,
}
